// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-72eb1af4] .layoutCard .cardBody{margin-bottom:30px}[data-v-72eb1af4] .iconEye:hover{color:var(--featuredFont);-webkit-user-select:none;-moz-user-select:none;user-select:none}[data-v-72eb1af4] .addressDescription{font-size:14px;font-weight:400}", ""]);
// Exports
module.exports = exports;
